import { PoStorageService } from "@po-ui/ng-storage";

export interface IFiltroListaIntegracaoGtr {
  lastSetDefault: Date;

  CD3OP: string;
  DD3EMISSAO_DE: Date | undefined;
  DD3EMISSAO_ATE: Date | undefined;
}

export class FiltroListaIntegracaoGtr {

  dados: IFiltroListaIntegracaoGtr;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-lista-integracao-gtr';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroListaIntegracaoGtr) => {
      if (filtro) {

        const {
          lastSetDefault,
          DD3EMISSAO_DE,
          DD3EMISSAO_ATE,
          CD3OP
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            DD3EMISSAO_DE: DD3EMISSAO_DE ? new Date(DD3EMISSAO_DE) : undefined,
            DD3EMISSAO_ATE: DD3EMISSAO_ATE ? new Date(DD3EMISSAO_ATE) : undefined,
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroListaIntegracaoGtr => {
    return {
      lastSetDefault: new Date(),
      DD3EMISSAO_DE: this.getData(-30),
      DD3EMISSAO_ATE: new Date(),
      CD3OP: '',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
  